import PropTypes from 'prop-types';

const SettingsPanel = ({ title, children }) => {
  return (
    <div className="flex flex-col rounded-xl border border-ivory-50 overflow-hidden">
      <div className="text-lg font-medium px-4 py-2 bg-ivory-50">{title}</div>
      <div className="p-4">{children}</div>
    </div>
  );
};

SettingsPanel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default SettingsPanel;
